var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.482 15.84a3.822 3.822 0 01-2.703-1.152C.423 13.315.046 10.92 1.946 8.995L9.745 1.1c.79-.8 1.796-1.11 2.758-.848a2.853 2.853 0 011.974 1.999c.258.976-.047 1.994-.836 2.794l-7.459 7.552c-.425.431-.907.686-1.39.738a1.52 1.52 0 01-1.256-.428c-.58-.59-.662-1.694.302-2.67l5.239-5.304a.547.547 0 01.779 0 .563.563 0 010 .789l-5.24 5.305c-.452.457-.494.895-.3 1.09a.43.43 0 00.36.108c.226-.023.485-.173.727-.417l7.458-7.551c.512-.518.708-1.128.553-1.716a1.73 1.73 0 00-1.195-1.21c-.58-.158-1.184.041-1.696.56L2.725 9.786c-1.453 1.47-1.105 3.164-.167 4.114.938.95 2.61 1.303 4.063-.17l7.798-7.896a.547.547 0 01.78 0 .563.563 0 010 .79l-7.8 7.896c-.918.93-1.948 1.32-2.917 1.32z",
    fill: "currentColor"
  })));
}

export default SvgAttachment;